import { level_max, max_levels } from '../components/Tree/shema'
import { uuidv4 } from '../components/Tree/helper'

export default {
    methods: {
        filterElement() {
            var e = {
                title: this.title,
                type: this.type,
                emoji: this.emoji,
            }

            switch (e.type) {
                case 'nested':
                    e['call_to_actions'] = this.call_to_actions || []
                    break
                case 'postback':
                    e['payload'] = this.payload || ''
                    break
                case 'web_url':
                    e['url'] = this.url || ''
                    e['webview_height_ratio'] = this.webview_height_ratio || 'full'
                    break
            }

            return e
        },
        add() {
            this.call_to_actions.push({})
            this.handleOnChange()
        },
        remove(list, i) {
            if (list && list[i]) {
                list.splice(i, 1)
                this.handleOnChange()
            }
        },
        uuidv4() {
            return window.id()
        },
    },

    computed: {
        addStatus() {
            return this.call_to_actions.length >= level_max[this.level]
        },
    },
}
